import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_GATEWAY_PATH } from '@impact/data';
import { Observable } from 'rxjs';

export interface INewsletterSubscribe {
    firstName: string;
    lastName: string;
    email: string;
    consentRevisionAcceptedGuid: string;
    siteName: string;
}

@Injectable({
    providedIn: 'root',
})
export class NewsletterService {
    constructor(
        private http: HttpClient
    ) {}

    newsletterSignup(reqBody: any): Observable<any> {
        return this.http.post<any>(`/${API_GATEWAY_PATH}/Newsletter/Subscribe`, reqBody);
    }
}
